if (!customElements.get('localization-form-select')) {
  customElements.define(
    'localization-form-select',
    class LocalizationFormSelect extends HTMLElement {
      constructor() {
        super();
        this.querySelector('select').addEventListener('change', this.onSelectChange.bind(this));
      }

      onSelectChange(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        if (form) form.submit();
      }
    }
  );
};

// Cookie utility functions
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const setCookie = (name, value, days = 365) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

// Geolocalization popup logic
const geolocalizationPopup = document.querySelector('.geolocalization-popup');

if (geolocalizationPopup) {
  const button = geolocalizationPopup.querySelector('.geolocalization-popup-button');
  const closeButton = geolocalizationPopup.querySelector('.geolocalization-popup-close');
  const select = geolocalizationPopup.querySelector('select');
  
  // Check if geolocalization cookie exists
  const geolocalizationCookie = getCookie('geolocalization_confirmed');

  console.log(geolocalizationCookie);
  
  if (!geolocalizationCookie || geolocalizationCookie === 'dismissed') {
    // Show popup if no cookie exists
    geolocalizationPopup.showModal();
  }
  
  // Handle confirm button click
  button.addEventListener('click', () => {
    const selectedValue = select.value;
    
    // Set cookie with selected value
    setCookie('geolocalization_confirmed', selectedValue);
    
    console.log(selectedValue);
    
    // Close the popup
    geolocalizationPopup.close();
  });
  
  // Handle close button click
  closeButton.addEventListener('click', () => {
    // Set a cookie to remember user dismissed the popup
    setCookie('geolocalization_confirmed', 'dismissed');
    geolocalizationPopup.close();
  });
  
  // Handle clicking outside the popup
  geolocalizationPopup.addEventListener('click', (e) => {
    if (e.target === geolocalizationPopup) {
      setCookie('geolocalization_confirmed', 'dismissed');
      geolocalizationPopup.close();
    }
  });
}